import type React from "react";
import { useParams } from "react-router";
import { i18n } from "@frontend/i18n";
import { useEventSubdomain } from "@/shared/presentation/hooks/useEventSubdomain";
import { EventLandingPage } from "./EventLandingPage";

export function JoinEventRoute(): React.JSX.Element {
  const { eventIdPublicOrSlug: paramId } = useParams<{
    eventIdPublicOrSlug: string;
  }>();
  const subdomain = useEventSubdomain();
  const eventIdPublicOrSlug = paramId ?? subdomain ?? undefined;

  if (eventIdPublicOrSlug === undefined) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-card px-6">
        <p className="text-center text-muted-foreground">
          {i18n.t("user.eventLanding.invalidLink")}
        </p>
      </div>
    );
  }
  return <EventLandingPage eventIdPublicOrSlug={eventIdPublicOrSlug} />;
}
